/* eslint-disable */
import React from "react";

const FundManagement = () => {
    return("FundManagement");
}

export default FundManagement;